import { Directive, ElementRef, HostListener, Input } from '@angular/core';

import { NSCommonConstants } from '@ruby/configs/common.constants';

@Directive({
  selector: '[ngNumbersOnly]'
})
export class NumbersOnlyDirective {
  @Input() floats?: boolean = false;
  @Input() max?: number;
  @Input() onlyDigits?: boolean = false;

  constructor(private el: ElementRef) { }

  @HostListener('keypress', ['$event']) onKeyPress(event: KeyboardEvent) {
    const val: string = this.el.nativeElement.value + event.key;
    const chunks: Array<string> = val.split('.');
    if (chunks.length === 2 && chunks[1].length === 3) {
      return false;
    }
    return this.isValidNumber(this.floats ? val : event.key);
  }

  @HostListener('paste', ['$event']) onPaste(event: ClipboardEvent) {
    const value = event.clipboardData?.getData('text/plain');
    if (!this.isValidNumber(value)) {
      event.preventDefault();
    }
  }

  @HostListener('drop', ['$event']) onDrop(event: DragEvent) {
    const value = event.dataTransfer?.getData('text/plain');
    if (!this.isValidNumber(value)) {
      event.preventDefault();
    }
  }

  private isValidNumber(value?: string): boolean {
    if (value) {
      if (this.max && Number(value) > this.max) {
        return false;
      }
      if (this.floats) {
        return NSCommonConstants.numbersWithDecimalsPattern.test(value);
      } else if (this.onlyDigits) {
        return NSCommonConstants.numbersOnlyWithoutCommaPattern.test(value);
      }
      return NSCommonConstants.numbersOnlyPattern.test(value);
    } else {
      return false;
    }
  }
}
